<div class="age-status-container">
    <div class="age-status-row">
        <div class="status-display">

            <div class="age-section">
                <span class="age-info">Edad:</span>
                <span class="age-value" *ngIf="!isCalculatingAgeStatus">{{ calculatedAge }}</span>
                <mat-progress-spinner *ngIf="isCalculatingAgeStatus" diameter="20"
                    mode="indeterminate"></mat-progress-spinner>
            </div>
            <div class="classification-section">
                <span class="classification-label">
                    Clasificación:
                </span>

                <!-- Vista de lectura  -->
                <div class="classification-info" *ngIf="!hasManualOverride">
                    <span class="classification-value">{{ calculatedAgeStatusName }}</span>
                    <div class="classification-button">
                        <button mat-button type="button" (click)="openEditMode()">
                            <mat-icon>edit</mat-icon>
                            Manual
                        </button>
                    </div>
                </div>

                <!-- Vista de edición  -->
                <div class="classification-info" *ngIf="hasManualOverride">
                    <mat-button-toggle-group [value]="ageStatusOverrideControl.value"
                        (change)="onAgeStatusOverrideChange($event)" class="classification-value">
                        <mat-button-toggle *ngFor="let status of ageStatusOptions" [value]="status.value">
                            {{ status.label }}
                        </mat-button-toggle>
                    </mat-button-toggle-group>

                    <button mat-icon-button class="classification-button" (click)="onCloseEdit()" matTooltip="Calcular automáticamente">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>